module.exports = __webpack_public_path__ + "img/image83.baede9a6.png";